import {InjectionToken} from '@angular/core';
import {Observable} from 'rxjs';

export interface MxTranslateService {
    getTranslatedLabel(label: string): string;

    readonly translationsChanged$?: Observable<unknown>;
}
export const MX_TRANSLATE_SERVICE_TOKEN = new InjectionToken<MxTranslateService>('MX_TRANSLATE_SERVICE_TOKEN');
